/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "Statement": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "type": {
                        "type": ".squareup.sfs.external.models.Statement.Type",
                        "id": 2,
                        "rule": "optional"
                      },
                      "month": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "year": {
                        "type": "uint32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "downloadUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Type": {
                        "values": {
                          "STATEMENT_TYPE_DO_NOT_USE": 0,
                          "MONTHLY": 1,
                          "TAX_1099_INT": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Statement && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.Statement?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a statement which can be of type monthly or 1099-INT Tax statement
 * --
 *
 * SOURCE Statement @ squareup/sfs/external/models/statement.proto at 10:1
 */
export const Statement = $root.lookupType('squareup.sfs.external.models.Statement');
fixType(Statement, {
  id: {
    required: true
  },
  type: {
    required: true
  },
  customerId: {
    required: true
  }
});
Builder.createAndAttachToType(Statement);
/**
 * SOURCE Type @ squareup/sfs/external/models/statement.proto at 11:3
 */
Statement.Type = $root.lookupEnum('squareup.sfs.external.models.Statement.Type').values;